import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bergh-alert-popover',
    templateUrl: './alert-popover.component.html',
    styleUrls: ['./alert-popover.component.scss'],
    standalone: false
})
export class AlertPopoverComponent implements OnInit {
  @Input() isBulkMove = false;
  @Input() commonFpList = [];
  @Input() isEdit : boolean = false;
  public selectedZone = '';
  @Output() cancel: EventEmitter<boolean> = new EventEmitter();
 
  @Output() fpData: EventEmitter<{isMove: boolean, data: any}> = new EventEmitter();
  public selectedFpAndZone = [];
  constructor() { }

  ngOnInit(): void {
    this.getSelectedZone();
  }
  getSelectedZone(data?, i?, fp?) { 
    let commonList = this.commonFpList;
   
    if(this.commonFpList.length !== 0) {
      if(data!== undefined) {
        commonList[i].selectedZoneId = data;
      } else {
        commonList[0].selectedZoneId = data;
      }
    }
    let FP_LIST = [];
    FP_LIST = commonList.map(ele=>{
      return {
        'firePartitionIds': ele.fp._id,
        'zoneId': ele.selectedZoneId === undefined ? ele.zone[0].zone_id : ele.selectedZoneId
      }
    });
    const DATA = this.commonFpList.map(item => item.zone)
  .filter((value, index, self) => self.indexOf(value) === index);
    let COMMON = [];
    DATA.forEach(ele=> {
      ele.forEach(item => {
        COMMON.push(item);
      })
    })
    const DATA1 = COMMON.map(item => item)
    .filter((value, index, self) => self.indexOf(value) === index);
    var output = [];
    FP_LIST.forEach(function (item) {
      var existing = output.filter(function (v, i) {
        return v.zoneId == item.zoneId;
      });
      if (existing.length) {
        var existingIndex = output.indexOf(existing[0]);
        output[existingIndex].firePartitionIds = output[existingIndex].firePartitionIds.concat(item.firePartitionIds);
      } else {
        if (typeof item.firePartitionIds == 'string')
          item.firePartitionIds = [item.firePartitionIds];
        output.push(item);
      }
    });
    this.selectedFpAndZone = output;
  }
  getAllSelectedData(isMove) {
    this.isEdit = false;
    this.fpData.emit({'isMove': isMove,'data': this.selectedFpAndZone});
  }
  getDataIfNoSelected(isMove) {
    this.isEdit = true;
    this.fpData.emit({'isMove': isMove,'data': this.selectedFpAndZone});
  }
}
